<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div id="popup" :class="isSidebarActiveLocal ? 'active' : ''">
    <div class="popup-cont">
      <h2 class="popup-heading">DUPLICATE ACCOUNT</h2>
      <div class="user-edit-row">
        <h4>First Name*</h4>
        <input type="text" class="tr-input" v-model="name" name="Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Last Name</h4>
        <input type="text" class="tr-input" v-model="last_name" name="Last Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Email*</h4>
        <input type="email" class="tr-input" v-model="email" name="Email" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Restaurant Name*</h4>
        <input type="text" class="tr-input" v-model="restaurant_name" name="Restaurant Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Restaurant Name')">{{ errors.first('Restaurant Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Password</h4>
        <input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:10'"
          name="password"
          label="Password"
          placeholder="Password"
          v-model="password"
          class="tr-input" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

      </div>
      <div class="user-edit-row">
        <h4>Password</h4>

        <input
          type="password"
          ref="confirm-password"
          v-validate="'min:6|max:10|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm-password"
          label="Confirm Password"
          placeholder="Confirm Password"
          v-model="confirm_password"
          class="tr-input" />
        <span class="text-danger text-sm">{{ errors.first('confirm-password') }}</span>

      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" @click="submitData">Confirm</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import Places from '../../../components/google-places/Places'
import Reviews from '../../../components/google-places/Reviews'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Reviews,
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    Places
  },
  data () {
    return {
      id: null,
      name: '',
      last_name: '',
      email: '',
      phone: '',
      dataImg: null,
      uploadImg: null,
      restaurant_name: '',
      user_group: null,
      photo: '',
      format: 'yyyy-MM-dd',
      password: '',
      confirm_password: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true && !this.data.duplicating) {
        this.initValues()
        this.$validator.reset()
        this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      } else {
        const { name, id, last_name, phone, email, user_group, photoUrl, photo, user_property} = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.last_name = last_name
        this.phone = phone
        this.email = email
        this.user_group = user_group
        this.dataImg = (photoUrl !== null) ? photoUrl : require('@/assets/images/pages/register/upload_image.png')
        this.photo = photo
        this.user_property = user_property
        this.restaurant_name = user_property['Restaurant-Name']
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    user_property: {
      get () {
        return this.$store.state.api.propertylist
      },
      set (val) {
        if (val) {
          this.$store.dispatch('api/setPropertyListForUser', val)
        }
      }
    },
    isFormValid () {
      if (this.data.add) {
        return !this.errors.any()
      } else {
        return !this.errors.any()
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    isFieldRequired (field) {
      if (field.code === 'Restaurant-Name' || field.code === 'Address' || field.code === 'Alias' || field.code === 'tax') {
        return 'required'
      }
      return ''
    },
    changePlace () {
      this.user_property['Google-Places-ID'] = null
    },
    placesFound (value) {
      this.user_property['Google-Places-ID'] = value.place_id
    },
    onDateChange (code_in, $event) {

      const payload = { code: code_in, val: this.getFormattedDate($event)}
      this.$store.dispatch('api/setPropertyListItemForUser', payload)
    },
    onDataChange (code_in, $event) {
      const payload = { code: code_in, val: $event}
      this.$store.dispatch('api/setPropertyListItemForUser', payload)
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]

        const img_obj = {
          restaurantId: this.id,
          file: this.uploadImg
        }

        this.$store.dispatch('api/uploadImageProfile', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          this.$vs.notify({
            title: 'Image uploaded',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$vs.loading.close()
        }).catch(err => {
          console.error(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    },
    getFormattedDate (date) {
      return moment(date).format('yyyy-MM-DD')
    },
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.last_name = ''
      this.email = ''
      this.user_group = null
      this.phone = ''
      this.uploadImg = null

    },
    createHours (id, callback) {

      const dataPickup = {
        'hourType':2,
        'restaurant_id':id,
        'hours':[
          {
            'dayId':1,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':2,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':3,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':4,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':5,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':6,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':7,
            'opening':'09:00',
            'closing':'20:00'
          }
        ]
      }

      const dataDelivery = {
        'hourType':1,
        'restaurant_id':id,
        'hours':[
          {
            'dayId':1,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':2,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':3,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':4,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':5,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':6,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':7,
            'opening':'09:00',
            'closing':'20:00'
          }
        ]
      }

      this.$store.dispatch('api/saveWeeklyHours', dataPickup).then(() => {
        this.$store.dispatch('api/saveWeeklyHours', dataDelivery).then(() => {
          callback()
        }).catch(err => {
          callback(err.message)
        })
      }).catch(err => {
        callback(err.message)
      })

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          this.user_property['Restaurant-Name'] = this.restaurant_name
          this.user_property['Stripe-ID'] = ''
          this.user_property['Alias'] = `${this.restaurant_name.replace(' ', '-').replace(',', '')}-${this.user_property['Address'].split(' ').splice(0, 3).join('-').replace(',', '')}`
          const payload = {
            email: this.email,
            name: this.name,
            last_name: this.last_name,
            user_group: this.user_group,
            property: this.user_property,
            phone: this.phone,
            active: 1
          }
          payload['password'] = this.password
          payload['confirmPassword'] = this.confirm_password

          if (this.photo) {
            payload.photo = this.photo
          }

          this.$store.dispatch('api/registerUser', payload).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })

            if (this.data.duplicating) {
              const copy_restaurant_id = response.data.data.id
              const duplicate_data = {
                copyRestaurant: copy_restaurant_id,
                restaurantId: this.data.duplicating_id
              }
              this.$store.dispatch('api/duplicateUser', duplicate_data).then(() => {

                this.createHours(copy_restaurant_id, (err) => {
                  if (err) {
                    this.$vs.loading.close()
                    this.$vs.notify({
                      title: 'Error',
                      text: err,
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                    return
                  }

                  this.$vs.notify({
                    title: 'Success',
                    text: 'Duplicated',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    color: 'success'
                  })
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$vs.loading.close()
                  location.reload()
                })
              }).catch(err => {
                console.error(err.message)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })
            } else {
              this.$emit('closeSidebar')
              this.initValues()
              this.$vs.loading.close()
            }
          }).catch(err => {
            console.error(err.message)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
